import { generateUrlByQuery } from "@stadium/helpers/dom";
import { canonicalizeMySpacePath } from "@stadium/helpers/routes";
import {
  STORE_BRAND_PAGE_PATHNAME,
  STORE_COLLECTION_PAGE_PATHNAME,
  MENU_PAGE_PATHNAME,
  PRODUCT_VIEW_PATHNAME,
  HEADER_NAV_LINK_PATHNAME_PREFIX,
  CATALOG_ENTRIES_PAGE_PATHNAME,
  CATALOG_PAGE_PATHNAME,
  OLD_STORE_BRAND_PAGE_PATHNAME,
  OLD_STORE_COLLECTION_PAGE_PATHNAME,
  OLD_MENU_PAGE_PATHNAME,
  OLD_PRODUCT_VIEW_PATHNAME,
  STORE_HOME_PAGE_PATHNAME,
  OLD_STORE_HOME_PAGE_PATHNAME,
} from "@stadium/shared/src/constants/stores/routes";

export const getStoreHomePageUrl = ({
  queryForRoutePath,
  baseOrigin,
  isNewRouteEnabled,
}: {
  queryForRoutePath: any;
  baseOrigin?: string;
  isNewRouteEnabled?: boolean;
}) => {
  return generateUrlByQuery({
    pathname: isNewRouteEnabled ? STORE_HOME_PAGE_PATHNAME : OLD_STORE_HOME_PAGE_PATHNAME,
    query: queryForRoutePath,
    ...(baseOrigin ? { baseOrigin } : {}),
  });
};


export const getCatalogNavLinkUrl = ({
  queryForRoutePath,
  baseOrigin,
  isNewRouteEnabled,
}: {
  queryForRoutePath: any;
  baseOrigin?: string;
  isNewRouteEnabled?: boolean;
}) => {
  const href = generateUrlByQuery({
    pathname: isNewRouteEnabled ? CATALOG_PAGE_PATHNAME : OLD_STORE_HOME_PAGE_PATHNAME,
    query: queryForRoutePath,
    ...(baseOrigin ? { baseOrigin } : {}),
  });
  return canonicalizeMySpacePath(href);
};

export const getBrandUrl = ({
  brandKey,
  queryForRoutePath,
  baseOrigin,
  isNewRouteEnabled,
}: {
  brandKey: any;
  queryForRoutePath: any;
  baseOrigin?: string;
  isNewRouteEnabled?: boolean;
}) => {
  const brandUrlQuery = {
    ...queryForRoutePath,
    brandSlug: brandKey,
  };

  const brandUrl = generateUrlByQuery({
    pathname: isNewRouteEnabled ? STORE_BRAND_PAGE_PATHNAME : OLD_STORE_BRAND_PAGE_PATHNAME,
    query: brandUrlQuery,
    ...(baseOrigin ? { baseOrigin } : {}),
  });

  return canonicalizeMySpacePath(brandUrl);
};

export const getCollectionUrl = ({
  menuIdentifier,
  queryForRoutePath,
  baseOrigin,
  isNewRouteEnabled,
}: {
  menuIdentifier: string;
  queryForRoutePath: any;
  baseOrigin?: string;
  isNewRouteEnabled?: boolean;
}) => {
  const collectionUrlQuery = {
    ...queryForRoutePath,
    menuIdentifier,
  };

  const collectionUrl = generateUrlByQuery({
    pathname: isNewRouteEnabled
      ? STORE_COLLECTION_PAGE_PATHNAME
      : OLD_STORE_COLLECTION_PAGE_PATHNAME,
    query: collectionUrlQuery,
    ...(baseOrigin ? { baseOrigin } : {}),
  });

  return canonicalizeMySpacePath(collectionUrl);
};

export const getCatalogEntriesPageUrl = ({
  categorySlug,
  queryForRoutePath,
  baseOrigin,
  isNewRouteEnabled,
}: {
  categorySlug: any;
  queryForRoutePath: any;
  baseOrigin?: string;
  isNewRouteEnabled?: boolean;
}) => {
  if (!categorySlug) {
    return getCatalogNavLinkUrl({ queryForRoutePath, baseOrigin, isNewRouteEnabled });
  }

  const categoryUrlQuery = {
    ...queryForRoutePath,
    ...(isNewRouteEnabled ? { categorySlug } : { category: categorySlug }),
  };

  const href = generateUrlByQuery({
    pathname: isNewRouteEnabled ? CATALOG_ENTRIES_PAGE_PATHNAME : OLD_MENU_PAGE_PATHNAME,
    query: categoryUrlQuery,
    ...(baseOrigin ? { baseOrigin } : {}),
  });

  return canonicalizeMySpacePath(href);
};


export const getCategoryUrl = ({
  category,
  queryForRoutePath,
  query,
  baseOrigin,
  isNewRouteEnabled,
}: {
  category: any;
  queryForRoutePath: any;
  query?: any;
  baseOrigin?: string;
  isNewRouteEnabled?: boolean;
}) => {
  const categoryUrlQuery = {
    ...queryForRoutePath,
    category,
    ...(query ?? {}),
  };

  const menuPathname = isNewRouteEnabled ? MENU_PAGE_PATHNAME : OLD_MENU_PAGE_PATHNAME;
  const catalogPathname = isNewRouteEnabled ? CATALOG_PAGE_PATHNAME : OLD_STORE_HOME_PAGE_PATHNAME;

  const href = generateUrlByQuery({
    pathname: category ? menuPathname : catalogPathname,
    query: categoryUrlQuery,
    ...(baseOrigin ? { baseOrigin } : {}),
  });

  return canonicalizeMySpacePath(href);
};

export const getProductUrl = ({
  productSlug,
  queryForRoutePath,
  baseOrigin,
  isNewRouteEnabled,
}: {
  productSlug: any;
  queryForRoutePath: any;
  baseOrigin?: string;
  isNewRouteEnabled?: boolean;
}) => {
  const productUrlQuery = {
    ...queryForRoutePath,
    productSlug,
  };

  const href = generateUrlByQuery({
    pathname: isNewRouteEnabled ? PRODUCT_VIEW_PATHNAME : OLD_PRODUCT_VIEW_PATHNAME,
    query: productUrlQuery,
    ...(baseOrigin ? { baseOrigin } : {}),
  });

  return canonicalizeMySpacePath(href);
};

export const getHeaderNavLinkUrl = (queryForRoutePath: any, baseOrigin?: string) => {
  // Header-nav prefix is `/[countryCode]` — no workspace segment, so canonicalization
  // is a no-op. Left out intentionally to keep this hot path cheap.
  return generateUrlByQuery({
    pathname: HEADER_NAV_LINK_PATHNAME_PREFIX,
    query: {
      countryCode: queryForRoutePath.countryCode,
    },
    ...(baseOrigin ? { baseOrigin } : {}),
  });
};
